<a id="logo" class="logo" routerLink="/">
  <div class="svg" routerLink="/"></div>
  <div class="titles">
    <!--        <div class="title title1">Product Safety
					<div class="title title&#45;&#45;inverted">Reporting</div>
				</div>-->
    <div class="title title1 title-svg"></div>
    <div class="title title2">{{ env.projectTitle }}</div>
    <!--<div class="title title2">Product Safety Reporting Made Easy</div>-->
  </div>
</a>
